import { Text } from '@chakra-ui/react';
import { Quote } from '@pelicargo/types';
import { prettyDate } from '@pelicargo/utils';

type Props = {
  quote: Quote;
};

export const Validity = ({ quote }: Props) => {
  const validUntil = quote?.expires_at && prettyDate(quote?.expires_at);

  if (!validUntil) return null;

  return (
    <Text textStyle="captionSmallRegular" justifySelf="flex-end" alignSelf="flex-end" mt="2">
      Valid until {validUntil}
    </Text>
  );
};
